var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSendWeb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icSendWeb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/icon/send",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sent-mail"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8930804,0.0801649426 C20.7996007,-0.00420637311 20.6665695,-0.0237810352 20.5538162,0.0300331348 L0.181641862,9.77033329 C0.0719648559,9.8227908 0.00133713279,9.93539356 1.87486288e-05,10.0598186 C-0.00129963554,10.1842437 0.0670052203,10.2983969 0.175614963,10.3532448 L4.47579264,12.2647658 C4.58151449,12.3181923 4.70757713,12.3061116 4.80199855,12.233498 L15.2911751,4.92229174 L7.47205518,13.5801569 C7.40927498,13.6466332 7.37725708,13.7376586 7.3841629,13.8300407 L7.8223059,19.7017287 C7.83203683,19.8318388 7.9167901,19.9430849 8.0372653,19.9838493 C8.06947154,19.9947026 8.10255671,20 8.13526519,20 C8.2249781,20 8.31224257,19.9603985 8.37295102,19.8880433 L11.4329835,16.2391454 L15.2158043,18.0990613 C15.2979208,18.1394381 15.39297,18.1411177 15.4764049,18.1037773 C15.5598398,18.0663722 15.6233734,17.9936294 15.65062,17.9043483 L20.9855557,0.419782099 C21.0228471,0.297682722 20.9864974,0.164536258 20.8930804,0.0801649426 Z",
    id: "Shape",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSendWeb);
export default __webpack_public_path__ + "static/media/icSendWeb.d04c3127ab0f06dd228cfda9fcf33690.svg";
export { ForwardRef as ReactComponent };